import React from 'react';

const Blogs = () => {
  return (
    <div>
      <h3>this is blog page</h3>
    </div>
  );
};

export default Blogs;